import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { RiEdit2Fill } from "react-icons/ri";
import { createOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
function EditBtn() {
  const { t } = useTranslation();

  return (
    <Link to="/edit" className="profile-action-btn edit-btn">
      {/* {t("editBtn.editProfile")} */}
      {/* <RiEdit2Fill style={{ fontSize: "1.8rem" }} /> */}
      <IonIcon
        slot="start"
        icon={createOutline}
        className="btn-icon"
        style={{ paddingBottom: "3px", lineHeight: "1" }}
      />
      <span className="btn-text">{t("editBtn.editProfile")}</span>
    </Link>
  );
}

export default EditBtn;
